import { Icon } from 'antd'
import { AppDate, AppInput } from 'components/AppFormItem'
import { formatValue } from 'utils'
import { AppSelectTree, AppTreeProps } from 'components/AppSelectTree'
import React, { Fragment, useContext, useEffect, useState, useLayoutEffect } from 'react'

import { AppGridAdvancedSearchItem as AppGridAdvancedSearchItemProps } from '../../api'
import { AppGridSearchContext } from './AppGridSearchContext'
import { AppSearchData, getSearchData, getValue, getCondition } from './AppGridSearchData'

// 项目树查询
interface AppProjectTreeSearchProps extends AppTreeProps {
	keyName: string
	dataType?: string
	field: string
	label?: string
}
export const AppProjectTreeSearch = (props: AppProjectTreeSearchProps) => {
	const { onChange, onSearch } = useContext(AppGridSearchContext)

	const hanldChange = (id: number) => {
		let appSearchData: AppSearchData = {
			keyName: props.keyName,
			field: [props.field],
			value: id.toString(),
			itemType: 'projectFilter',
			dataType: 'number',
			minValue: '',
			maxValue: '',
		}
		onChange(appSearchData)
		onSearch()
	}

	return (
		<div className="app-grid-common-search-item">
			<label className="app-grid-common-search-item-label">{props.label}</label>
			<div className="app-grid-common-search-item-component" style={{ width: 300 }}>
				<AppSelectTree scene={props.scene} onChange={data => hanldChange(data.id)} />
			</div>
		</div>
	)
}

export const AllCheck = (props: AppGridAdvancedSearchItemProps) => {
	const { appSearchDataList, clearSearchDataByField } = useContext(AppGridSearchContext)
	return (
		<div className="app-grid-advanced-search-item-part">
			<span
				className={`app-grid-advanced-search-item-allcheck ${
					getSearchData(appSearchDataList, props.keyName) ? '' : 'is-active'
				}`}
				onClick={e => clearSearchDataByField(props.keyName)}
			>
				全部
				<i className="qcciconfont-select app-grid-advanced-search-item-icon-selected" />
			</span>
		</div>
	)
}

// 高级查询

export const AppGridAdvancedSearchItem = (props: AppGridAdvancedSearchItemProps) => {
	const rendSearchItem = () => {
		switch (props.type) {
			case 'text':
				return <InputSearch {...props}></InputSearch>
			case 'select':
				return <SelectSearch {...props}></SelectSearch>
			case 'numberRange':
				return <NumberRangeSearch {...props}></NumberRangeSearch>
			case 'dateRange':
				return <DateRangeSearch {...props}></DateRangeSearch>
			default:
				return <Fragment />
		}
	}
	return <Fragment>{rendSearchItem()} </Fragment>
}

const InputSearch = (props: AppGridAdvancedSearchItemProps) => {
	const { onChange, onSearch, appSearchDataList } = useContext(AppGridSearchContext)

	const hanldChange = (value: string, text: string) => {
		let appSearchData: AppSearchData = {
			keyName: props.keyName,
			field: [props.field],
			value,
			itemType: 'text',
			dataType: 'string',
			minValue: '',
			maxValue: '',
			label: props.label,
			showCondition: value,
		}
		onChange(appSearchData)
		onSearch()
	}

	return (
		<Fragment>
			<AllCheck {...props} />
			<div className="app-grid-advanced-search-item-control">
				<div className="app-grid-searchor-field-content-div" style={{ width: 150 }}>
					<AppInput
						key={props.keyName}
						value={getValue(appSearchDataList, props.keyName)}
						onChange={(value: any, text: string) => hanldChange(value, text)}
					/>
				</div>
			</div>
		</Fragment>
	)
}

const SelectSearch = (props: AppGridAdvancedSearchItemProps) => {
	const { onChange, onSearch, appSearchDataList } = useContext(AppGridSearchContext)
	let appSearchData = getSearchData(appSearchDataList, props.keyName)
	const hanldChange = (selectd: any[]) => {
		let appSearchDataNew: AppSearchData = {
			keyName: props.keyName,
			field: [props.field],
			valueList: selectd,
			itemType: 'select',
			dataType: 'string',
			minValue: '',
			maxValue: '',
			label: props.label,
			showCondition: props.appGridAdvancedSearchItemOptionList
				.filter(e => selectd.find(f => f === e.value))
				.map(e => e.label)
				.join(','),
		}
		onChange(appSearchDataNew)
		onSearch()
	}

	return (
		<Fragment>
			<AllCheck {...props} />
			<SelectItem
				showMoreItem={props.showMoreItem}
				options={props.appGridAdvancedSearchItemOptionList}
				selectd={appSearchData && appSearchData.valueList}
				onChange={(selectd: any[]) => hanldChange(selectd)}
			/>
		</Fragment>
	)
}

const NumberRangeSearch = (props: AppGridAdvancedSearchItemProps) => {
	const { onChange, onSearch, appSearchDataList } = useContext(AppGridSearchContext)
	let appSearchData = getSearchData(appSearchDataList, props.keyName)
	const hanldChange = (minValue: any, maxValue: any) => {
		let appSearchDataNew: AppSearchData = {
			keyName: props.keyName,
			field: [props.field],
			itemType: 'numberRange',
			dataType: 'number',
			minValue,
			maxValue,
			label: props.label,
			showCondition: getCondition(minValue, maxValue),
		}
		onChange(appSearchDataNew)
		onSearch()
	}

	return (
		<Fragment>
			<AllCheck {...props} />
			<NumberRange
				minValue={appSearchData && appSearchData.minValue}
				maxValue={appSearchData && appSearchData.maxValue}
				onChange={(minValue: number, maxValue: number) => hanldChange(minValue, maxValue)}
			/>
		</Fragment>
	)
}

const DateRangeSearch = (props: AppGridAdvancedSearchItemProps) => {
	const { onChange, onSearch, appSearchDataList } = useContext(AppGridSearchContext)
	let appSearchData = getSearchData(appSearchDataList, props.keyName)
	const hanldChange = (minValue: string, maxValue: string) => {
		let appSearchDataNew: AppSearchData = {
			keyName: props.keyName,
			field: [props.field],
			itemType: 'dateRange',
			dataType: 'string',
			minValue,
			maxValue,
			label: props.label,
			showCondition: getCondition(formatValue(minValue, 'yyyy-MM-dd'), formatValue(maxValue, 'yyyy-MM-dd')),
		}
		onChange(appSearchDataNew)
		onSearch()
	}

	return (
		<Fragment>
			<AllCheck {...props} />
			<DateRange
				minValue={appSearchData && appSearchData.minValue}
				maxValue={appSearchData && appSearchData.maxValue}
				onChange={(minValue: string, maxValue: string) => hanldChange(minValue, maxValue)}
			/>
		</Fragment>
	)
}

interface SelectItemProps {
	showMoreItem: boolean
	options: any[]
	selectd: any[]
	onChange: (selectd: any[]) => void
}
const SelectItem = (props: SelectItemProps) => {
	const [showMoreItem, setShowMoreItem] = useState(props.showMoreItem)
	const [showMoreItemButton, setShowMoreItemButton] = useState(false)
	const { calAppGridSearchHeight } = useContext(AppGridSearchContext)
	useEffect(() => {
		setShowMoreItemButton(refDivContainer.current.clientHeight < refOptionsList.current.clientHeight)
	}, [])
	const selectedItem = (value: any, text: any) => {
		let selectd = (props.selectd && [...props.selectd]) || ([] as string[])
		if (selectd && selectd.find(s => s === value)) {
			selectd = selectd.filter(s => s !== value)
		} else {
			selectd.push(value)
		}
		props.onChange(selectd)
	}
	useLayoutEffect(() => {
		// DOM 更新完成后打印出 div 的高度

		calAppGridSearchHeight()
	})
	const refDivContainer = React.createRef<HTMLDivElement>()
	const refOptionsList = React.createRef<HTMLDivElement>()
	return (
		<div className="app-grid-advanced-search-item-control">
			<div className="app-grid-advanced-search-item-options">
				<div
					className="app-grid-advanced-search-item-options-container"
					style={showMoreItem ? { height: 'auto' } : {}}
					ref={refDivContainer}
				>
					<div className="app-grid-advanced-search-item-options-list" ref={refOptionsList}>
						{props.options &&
							props.options.map((option: any) => {
								return (
									<span
										key={option.value}
										title={option.label}
										className={`app-grid-advanced-search-item-options-item ${
											props.selectd && props.selectd.find((v: string) => v === option.value)
												? 'is-active'
												: ''
										}`}
										onClick={e => selectedItem(option.value, option.label)}
									>
										{option.label}
										<i className="qcciconfont-select app-grid-advanced-search-item-icon-selected" />
									</span>
								)
							})}
					</div>
					{showMoreItemButton ? (
						<span
							className="app-grid-advanced-search-item-options-more"
							onClick={e => setShowMoreItem(!showMoreItem)}
						>
							{showMoreItem ? '收起' : '更多'}
							<Icon
								type={showMoreItem ? 'up' : 'down'}
								style={{ fontSize: '12px', marginLeft: '3px', lineHeight: '26px' }}
							/>
						</span>
					) : (
						''
					)}
				</div>
			</div>
		</div>
	)
}

interface RangeProps {
	minValue: number | string
	maxValue: number | string
	onChange: (minValue: any, maxValue: any) => void
}
const NumberRange = (props: RangeProps) => {
	return (
		<div className="app-grid-advanced-search-item-control">
			<div className="app-grid-searchor-range-container">
				<div
					className="app-grid-searchor-field-content-div  app-grid-searchor-range-item"
					style={{ width: 150 }}
				>
					<AppInput
						dataType="number"
						value={props.minValue.toString()}
						placeholder="起始值"
						onChange={(value: any) => props.onChange(value, props.maxValue)}
					/>
				</div>
				<span className="app-grid-searchor-range-split">-</span>
				<div
					className="app-grid-searchor-field-content-div  app-grid-searchor-range-item"
					style={{ width: 150 }}
				>
					<AppInput
						dataType="number"
						value={props.maxValue.toString()}
						placeholder="截止值"
						onChange={(value: any) => props.onChange(props.minValue, value)}
					/>
				</div>
			</div>
		</div>
	)
}

const DateRange = (props: RangeProps) => {
	return (
		<div className="app-grid-advanced-search-item-control">
			<div className="app-grid-searchor-range-container">
				<div
					className="app-grid-searchor-field-content-div app-grid-searchor-range-item"
					style={{ width: 150 }}
				>
					<AppDate
						value={props.minValue && props.minValue.toString()}
						placeholder="开始时间"
						onChange={(value: any) => props.onChange(value, props.maxValue && props.maxValue.toString())}
					/>
				</div>
				<span className="app-grid-searchor-range-split">-</span>
				<div
					className="app-grid-searchor-field-content-div  app-grid-searchor-range-item"
					style={{ width: 150 }}
				>
					<AppDate
						value={props.maxValue && props.maxValue.toString()}
						placeholder="开始时间"
						onChange={(value: any) => props.onChange(props.minValue && props.minValue.toString(), value)}
					/>
				</div>
			</div>
		</div>
	)
}

export const Condition = () => {
	const { appSearchDataList, clearSearchDataByField } = useContext(AppGridSearchContext)
	return (
		<div className="app-grid-advanced-search-condition" style={{ display: '' }}>
			<div className="app-grid-advanced-search-condition-target">
				<div className="app-grid-advanced-search-condition-list">
					{appSearchDataList
						.filter(e => (e.showCondition || '') !== '')
						.map(d => {
							return (
								<span
									key={d.keyName}
									className="app-grid-advanced-search-condition-item"
									onClick={e => clearSearchDataByField(d.keyName)}
								>
									<span className="app-grid-advanced-search-condition-item-label">{d.label} :</span>
									<span
										title={d.showCondition}
										className="app-grid-advanced-search-condition-item-text"
									>
										{d.showCondition}
									</span>
									<b className="app-grid-advanced-search-condition-item-close">
										<Icon
											type="close"
											className="app-grid-advanced-search-condition-item-close-icon"
										></Icon>
									</b>
								</span>
							)
						})}
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppTableSearch/AppGridAdvancedSearchItem.tsx